import {
  AlertOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  HeartOutlined,
} from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const AdministrationOverviewPage = lazyRouteComponent(
  () => import('./pages/overview'),
);

const AdminAssistedImportsPage = lazyRouteComponent(
  () => import('./pages/assisted-imports'),
);

const AdministrationHealthPage = lazyRouteComponent(
  () => import('./pages/health'),
);

const AdministrationIncidentsPage = lazyRouteComponent(
  () => import('./pages/incidents'),
);

export const getRoutes = (): Route[] => [
  {
    page: AdministrationOverviewPage,
    path: ROUTE_PATHS.ADMIN_HOME,
    title: 'Visão geral',
    icon: DashboardOutlined,
    adminSection: 'operation',
    adminOrder: 0,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: AdministrationHealthPage,
    path: ROUTE_PATHS.ADMIN_HEALTH,
    title: 'Saúde da Plataforma',
    icon: HeartOutlined,
    adminSection: 'operation',
    adminOrder: 5,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: AdministrationIncidentsPage,
    path: ROUTE_PATHS.ADMIN_INCIDENTS,
    title: 'Incidentes',
    icon: AlertOutlined,
    adminSection: 'operation',
    adminOrder: 6,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: AdminAssistedImportsPage,
    path: ROUTE_PATHS.ADMIN_ASSISTED_IMPORTS,
    title: 'Importações assistidas',
    icon: CustomerServiceOutlined,
    adminSection: 'operation',
    adminOrder: 25,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
];
